import { render, staticRenderFns } from "./entity.vue?vue&type=template&id=41382efd&scoped=true"
import script from "./entity.vue?vue&type=script&lang=js"
export * from "./entity.vue?vue&type=script&lang=js"
import style0 from "./entity.vue?vue&type=style&index=0&id=41382efd&scoped=true&lang=css"
import style1 from "./entity.vue?vue&type=style&index=1&id=41382efd&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41382efd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41382efd')) {
      api.createRecord('41382efd', component.options)
    } else {
      api.reload('41382efd', component.options)
    }
    module.hot.accept("./entity.vue?vue&type=template&id=41382efd&scoped=true", function () {
      api.rerender('41382efd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/entity.vue"
export default component.exports